import React from 'react'
import PropTypes from 'prop-types'

function UserCoverActions({ onSubmit, onCancel }) {
  return (
    <div className="user-cover__actions">
      <button
        className="btn btn-outline-default btn-white btn-dark u-mr10"
        onClick={onCancel}
      >
        Cancel
      </button>
      <button
        className="btn btn-primary"
        onClick={onSubmit}
      >
        Save
      </button>
    </div>
  )
}

UserCoverActions.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default UserCoverActions
